import React from 'react';
import { Dropdown } from 'antd';
import { GlobalOutlined, DownOutlined } from '@ant-design/icons';
import { SUPPORTED_LANGS, useT } from './I18nContext';

/**
 * Header'da gösterilecek dil seçici dropdown.
 *
 * Antd Dropdown menü kullanır — flag emoji + label ile 8 dil.
 * Aktif dil bayrağı buton üzerinde, açıldığında listede ✓ ile işaretli.
 */
const LanguageSwitcher = ({ size = 'default', minimal = false }) => {
    const { lang, setLang, t } = useT();
    const active = SUPPORTED_LANGS.find(l => l.code === lang) || SUPPORTED_LANGS[0];

    const items = SUPPORTED_LANGS.map(l => ({
        key: l.code,
        label: (
            <span style={{
                display: 'flex', alignItems: 'center', gap: 8,
                padding: '2px 4px',
                fontWeight: l.code === lang ? 600 : 400,
            }}>
                <span style={{ fontSize: 16 }}>{l.flag}</span>
                <span>{l.label}</span>
                {l.code === lang && <span style={{ marginLeft: 'auto', color: '#52c41a' }}>✓</span>}
            </span>
        ),
        onClick: () => setLang(l.code),
    }));

    return (
        <Dropdown
            menu={{ items, selectedKeys: [lang] }}
            trigger={['click']}
            placement='bottomRight'
        >
            <button type='button'
                title={t('common.language')}
                aria-label={t('common.language')}
                style={{
                    display: 'inline-flex', alignItems: 'center', gap: 6,
                    background: 'transparent', border: 'none',
                    cursor: 'pointer',
                    padding: minimal ? '4px 6px' : '6px 10px',
                    borderRadius: 8,
                    fontSize: size === 'small' ? 12 : 13,
                    color: '#1f2937',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = '#f3f4f6'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
            >
                <GlobalOutlined style={{ fontSize: 16, color: '#9ca3af' }} />
                <span style={{ fontSize: 16 }}>{active.flag}</span>
                {!minimal && <span style={{ fontWeight: 500 }}>{active.label}</span>}
                <DownOutlined style={{ fontSize: 9, color: '#9ca3af' }} />
            </button>
        </Dropdown>
    );
};

export default LanguageSwitcher;
